import { useState, useEffect } from 'react';
import { Layout, CtaForm } from '../../components';
import facilityBotApi from '../../services/facilityBot';
import { ApiError } from '../../response_schemas/apiErrors';
import { Skeleton } from 'antd';


const FALLBACK_STATS = {
	assets: 100957,
	sensors_intergrated: 1901,
	sensor_data_points: 27165182,
	permit_to_work_applications: 4803,
	parts: 7117,
	meter_readings: 104135179,
	expenditures: 15772,
	licences: 3494,
	attendance_recorded: 75903,
	facilities_booked: 25036,
	visitors: 327696,
	desks_booked: 37907
};

const STATS_CONFIG = [
	{ key: 'assets', label: 'Assets' },
	{ key: 'sensors_intergrated', label: 'Sensors Integrated' },
	{ key: 'sensor_data_points', label: 'Sensors Data Points' },
	{ key: 'permit_to_work_applications', label: 'Permit to Work Applications' },
	{ key: 'parts', label: 'Parts' },
	{ key: 'meter_readings', label: 'Meters Readings' },
	{ key: 'expenditures', label: 'Expenditures' },
	{ key: 'licences', label: 'Licenses' },
	{ key: 'attendance_recorded', label: 'Attendance Recorded' },
	{ key: 'facilities_booked', label: 'Facilities Booked' },
	{ key: 'visitors', label: 'Visitors' },
	{ key: 'desks_booked', label: 'Desks Booked' }
];

export default function UsageStatistics() {
	const [stats, setStats] = useState(FALLBACK_STATS);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		async function fetchUsageStatistics() {
			try {
				const res = await facilityBotApi.get('/clients/usage_statistic');
				if (res?.data?.data) {
					const updatedStats = { ...FALLBACK_STATS };
					Object.keys(res.data.data).forEach((key) => {
						if (res.data.data[key] !== undefined && res.data.data[key] !== null) {
							updatedStats[key] = res.data.data[key];
						}
					});
					setStats(updatedStats);
				}
			} catch (err) {
				const error = new ApiError(err);
				console.error('Error fetching usage statistics:', error.errorMessage);
			} finally {
				setTimeout(() => {
					setLoading(false);
				}, 500);
			}
		}
		fetchUsageStatistics();
	}, []);

	return (
		<Layout pageName="Usage Statistics">
			<div className="resource-page resource-page--usage-stats">
				<section className="heading-container">
					<div className="container">
						<div className="heading">
							<h1 className="heading__title">Usage Statistics</h1>
							<h2 className="heading__desc">
								Real data demonstrating client usage of our features
							</h2>
						</div>
					</div>
				</section>

				<section className="usage-stats-section">
					<div className="container">
						<div className="usage-stats-grid">
							{STATS_CONFIG.map(({ key, label }, index) => (
								<div className="usage-stats-card" key={index}>
									<div className="usage-stats-card__content">
										<span className="usage-stats-card__label">{label}</span>
										<div className="usage-stats-card__value">
											<Skeleton loading={loading} active paragraph={false} title={{ width: '80%' }}>
												{stats[key]?.toLocaleString()}
											</Skeleton>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				</section>

				<CtaForm />
			</div>
		</Layout>
	);
}
